import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";

export default function* watcherGetRepaymentsSaga() {
  yield takeEvery("LOAD_REPAYMENT", workerSaga);
}

function* workerSaga(action) {
// <<<<<<< HEAD
  try {
    var payload = {};
    yield put({ type: "DISPLAY_LOADER", payload: payload });

    var formatUrl = "repayments/";
    yield request("get", payload, formatUrl).then((response) => {
      payload = response;
    });
    console.log(payload);

    yield put({ type: "REPAYMENTS", payload: payload });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  } catch (e) {
    console.log(e);
    console.log("product-saga", e);
    console.log("product-saga", e.response);
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  }
// =======
    try {
        var payload = {};
        yield put({ type: "DISPLAY_LOADER", payload: payload });
        var formatUrl = `repayments/`
        yield request("get", payload, formatUrl).then(response => {
            payload = response;
        });

        yield put({ type: "REPAYMENTS", payload: payload });
        yield put({ type: "DISPLAY_LOADER", payload: payload });
    } catch (e) {
        console.log(e);
        console.log("product-saga", e);
        console.log("product-saga", e.response);
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        const errorMessage = getErrorMessage(e.response);
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
        yield put({ type: "DISPLAY_LOADER", payload: payload });
    }
// >>>>>>> 7dcdaa73e4fc6d96e2fb604e4d160be10cb1457e
}
